import React from 'react';
import { format, isSameDay, isTomorrow, isWeekend } from 'date-fns';
import { useDroppable } from '@dnd-kit/core';
import { formatCustomDate } from '../../../utils/dateFormatters';
import { DayContainer, DayColumnHeader, DayLabel, ExpectedHours, IsTodayLabel, DayColumnBody } from '../styled';
import { DraggableEvent } from './DraggableEvent';
import { CalendarEvent, EventColorSet } from 'pages/Agenda/utils';

interface DayColumnProps {
  date: Date;
  events: CalendarEvent[];
  horasPrevistasLabel: string;
  dayIndex: number;
  onCardHover: (data: { event: CalendarEvent; rect: DOMRect; colorSet: EventColorSet }) => void;
  onCardLeave: () => void;
  isDragging: boolean;
  getColorSet: (event: CalendarEvent) => EventColorSet;
  isCompletedView: boolean;
}

export const DayColumn: React.FC<DayColumnProps> = ({
  date,
  events,
  horasPrevistasLabel,
  dayIndex,
  onCardHover,
  onCardLeave,
  isDragging,
  getColorSet,
  isCompletedView,
}) => {
  const { setNodeRef, isOver } = useDroppable({
    id: format(date, 'yyyy-MM-dd'),
  });

  const isToday = isSameDay(date, new Date());
  const isTomorrowDate = isTomorrow(date);
  const isWeekendDay = isWeekend(date);

  return (
    <DayContainer
      ref={setNodeRef}
      isFirst={dayIndex === 0}
      isLast={dayIndex === 6}
      isHighlighted={isToday}
      removeLeftBorder={isTomorrowDate}
      isWeekend={isWeekendDay}
      isDropTarget={isOver}
    >
      {isToday && <IsTodayLabel>Hoje</IsTodayLabel>}
      <DayColumnHeader>
        <DayLabel isHighlighted={isToday} isBlack={date.getTime() > new Date().getTime()}>
          {formatCustomDate(date)}
        </DayLabel>
        <ExpectedHours>{horasPrevistasLabel} previstas</ExpectedHours>
      </DayColumnHeader>
      <DayColumnBody>
        {events.map(event => (
          <DraggableEvent
            key={event.id}
            event={event}
            onHover={onCardHover}
            onLeave={onCardLeave}
            isDragging={isDragging}
            colorSet={getColorSet(event)}
            isCompletedView={isCompletedView}
          />
        ))}
      </DayColumnBody>
    </DayContainer>
  );
};
